import { Component, OnInit, Input } from '@angular/core';
import * as dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';
import * as timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);

import { ActiveDays } from '../working-days-of-week/working-days-of-week.component';
import { HttpParams } from '@angular/common/http';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-job-info-brief',
  templateUrl: './job-info-brief.component.html',
  styleUrls: ['./job-info-brief.component.scss'],
})
export class JobInfoBriefComponent implements OnInit {

  timeRange: string;
  dateRange: string;
  dressCode?: string;

  @Input()
  get jobInfo(): JobInfo { return this._jobInfo; }
  set jobInfo(jobInfo: JobInfo) {
    this._jobInfo = jobInfo;
    this.timeRange = this.formatTimeRange(dayjs(jobInfo.startTimestamp), dayjs(jobInfo.endTimestamp));
    this.dateRange = this.formatDateRange(dayjs(jobInfo.startTimestamp), dayjs(jobInfo.endTimestamp));
    if (jobInfo.dressCode) {
      this.dressCode = jobInfo.dressCode;
    } else {
      this.dressCode = undefined;
    }
  }
  private _jobInfo: JobInfo;

  constructor(private readonly userService: UserService,) { }

  ngOnInit() {
  }

  async onGetDirections() {
    const params = new HttpParams()
      .set('api', '1')
      .set('destination', `${this._jobInfo.addressLine1}, ${this._jobInfo.addressLine2}`);
    window.open(`https://www.google.com/maps/dir/?${params.toString()}`);
  }

  isUserEligible(): boolean {
    return this.userService.isCurrentUserEligible();
  }

  private formatDateRange(start: dayjs.Dayjs, end: dayjs.Dayjs) {
    if (start.year() !== end.year()) {
      return `${start.format('MMM D YYYY')} to ${end.format('MMM D YYYY')}`;
    }
    if (start.month() !== end.month()) {
      return `${start.format('MMM D')} to ${end.format('MMM D')}, ${start.format('YYYY')}`;
    }
    if (start.date() !== end.date()) {
      return `${start.format('MMM')} ${start.format('D')} - ${end.format('D')}, ${start.format('YYYY')}`;
    }
    return `${start.format('MMM D YYYY')}`;
  }

  private formatTimeRange(start: dayjs.Dayjs, end: dayjs.Dayjs) {
    return `${start.format('h:mma')} - ${end.format('h:mma')}`;
  }
}

export interface JobInfo {
  days: ActiveDays;
  startTimestamp: string;
  endTimestamp: string;
  addressLine1: string;
  addressLine2: string;
  dressCode?: string;
  lat: number;
  lng: number;
}
